import urlUtils = require("@arcgis/core/core/urlUtils"); // import statement with from is not working
import {ProxyConfiguration} from "./config/proxy-configuration";

export class GeoProxy {
    config: ProxyConfiguration;

    constructor(config: ProxyConfiguration) {
        this.config = config;
    }

    loadRules() {
        if (!this.config) {
            return false;
        }

        this.config.urlPrefixes.forEach((prefix) => {
            urlUtils.addProxyRule({
                proxyUrl: this.config.url,
                urlPrefix: prefix
            });
        });
    }
}
